import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography, breakpoints }: Theme) =>
  createStyles({
    topContent: {
      margin: '10px 0',
    },

    buttonAvatar: {
      display: 'block',
      padding: 5,
      borderRadius: 4,
      border: `1px solid ${palette.gray}`,
      margin: '0 auto 24px',
      '&:disabled': {
        opacity: 0.7,
      },
    },
    hiddenIcon: {
      display: 'none',
    },
    avatar: {
      width: 182,
      height: 182,
      background: palette.gray,
      fontSize: 40,
      fontWeight: typography.fontWeightMedium,
      letterSpacing: 3,
    },
    formContainer: {
      '& .MuiGrid-container': {
        alignItems: 'baseline',
      },
    },
    creationInfo: {
      padding: '25px 4px 5px 10px',
      justifyContent: 'flex-start',
    },
    creationText: {
      fontSize: 12,
      color: palette.darkGray,
    },
    spacingText: {
      paddingRight: 5,
      fontSize: 14,
    },
    background: {
      padding: 10,
    },
    personIconDefault: {
      color: palette.deepBlue,

      [breakpoints.up('md')]: {
        width: 40,
        height: 40,
      },
      [breakpoints.down('sm')]: {
        width: 30,
        height: 30,
      },
    },
    personIconSuperAdmin: {
      color: palette.darkGray,
    },
    personIconAdmin: {
      color: palette.navAdmin,
    },
    personIconOperator: {
      color: palette.navOperator,
    },
    container: {
      padding: '0 10px 10px 10px',
      alignItems: 'center !important',
      width: '100%',
    },
    cardTitles: {
      paddingRight: 7,
      fontWeight: 600,
      fontSize: 14,
      fontFamily: 'Roboto',
      display: 'flex',
      alignItems: 'center',
    },
    cardName: {
      paddingLeft: 7,
      fontWeight: 500,
      fontSize: 22,
      fontFamily: 'Roboto',
      [breakpoints.up('md')]: {
        fontSize: 22,
      },
      [breakpoints.down('sm')]: {
        fontSize: 18,
      },
    },
    cardInfos: { paddingTop: 10, paddingLeft: 10 },
    alignLines: { alignItems: 'center !important', justifyContent: 'center' },
    cardContent: { alignItems: 'baseline !important' },
    responsiveGrid: {
      display: 'none',
      [breakpoints.up('md')]: {
        display: 'flex',
        alignItems: 'baseline',
      },
      [breakpoints.down('sm')]: {
        display: 'flow-root',
        alignItems: 'baseline',
      },
    },
    cardValues: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 14,
    },
  });
